import React, { useContext } from "react";
import { NavLink, useLocation } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";
import { getCDNImage } from '../globals';
import { i18nValue } from '../functions';
import { HotelContext } from "../context/hotel";

const SubPagesList = ({ data, language }) => {
    return (
        <div className="generic-card-list row">
            {data && data.length > 0 && data.map((item) => {
                return <SubPageItem key={item.id || item.code} item={item} language={language} />
            })}
            {!data && data.length === 0 && <p>Sin datos</p>}
        </div>
    )
}

const SubPageItem = ({ item, language }) => {
    const { getUrlPath } = useContext(HotelContext);
    const { pathname } = useLocation();
    const link = getUrlPath(item.code);

    if (item?.visible == false) {
        return null;
    }
    return (
        <div className="col-12 col-md-6 col-lg-4">
            <Row>
                <Col>
                    <NavLink style={{ color: 'black', width: '100%', textDecoration: 'none' }} to={`${link}`} state={{ from: pathname }} >
                        <div className="generic-card">
                            <div className="generic-card-img" style={{ backgroundImage: "url(" + getCDNImage(item.image) + ")" }}>
                            </div>
                            <div className="generic-card-body">
                                <div className="generic-card-title" style={{ textTransform: 'uppercase' }}>{i18nValue(item, 'title', language)}</div>
                            </div>
                        </div>
                    </NavLink>
                </Col>
            </Row>
        </div>
    )
}

export default SubPagesList;
